<div class="d-flex flex-row gap-0 align-items-start target">
    <app-select-input-row [bindLabel]="bindLabel" [bindValue]="bindValue" [label]="label" [placeholder]="placeholder"
        [errorMessage]="errorMessage" [control]="control" [fetchFn]="fetchFn" [fetchSelectedItem]="fetchSelectedItem"
        [width]="width" class="w-100" [id]="id" [writeValueFlag]="writeValue"></app-select-input-row>
    <app-button icon="assets/media/general/plus.svg" btnBgColor="#36A3F7" btnHoverBgColor="#36A3F7"
        btnTextColor="#FFFFFF" btnHoverTextColor="#FFFFFF" (click)="add.emit()" *ngIf="!control.disabled"></app-button>
</div>